import WorkerProfileDto from '@/models/Workers/WorkerProfileDto';
import SelectableEntity from '@/models/Shared/SelectableEntity'

export default class JobBrowseWorkersViewModel {
    workerProfiles: SelectableEntity<WorkerProfileDto>[] = [];
    selectedWorkerId = "";
    selectedWorkerIds: string[] = [];
    selectedWorker: WorkerProfileDto = new WorkerProfileDto();
    //workersForQuickBook: WorkerProfileDto[] = [];
    //selectedWorkerForQuickBook: WorkerProfileDto = new WorkerProfileDto();
    //payRateForQuickBook: number = 0;
    //availabilitySummariesForQuickbook: AvailabilityRestrictionSummary[] = [];
}